import { Component } from "./index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import { ScrollTrigger } from "@gsap"

export default class Menu extends Component {
  constructor(obj) {
    super(obj)

    this.data = []
    this.bgs = qsa("[data-bg]")
    this.mobileIcon = qs(".mobile-icon", this.el)
    this.mobileMenu = qs(".mobile-menu", this.el)
    this.logo = qs(".logo", this.el)
    this.miniCart = qs(".mini-cart-trigger", this.el)

    this.desktopLinks = qsa(".header-nav .link", this.el)

    this.isActive = false
    this.logoTimeline = gsap.timeline({ paused: true })
    this.current = 0
    const page = qs("[data-taxi-view]")

    const firstSection = page.firstElementChild

    this.announcementBar = qs(".announcement-bar-section")
    this.headerContent = qs(".header-content", this.el)
    this.headerLogo = qs(".header-logo", this.el)

    this.headerContent.style.paddingTop = ""
    this.headerLogo.style.top = ""

    if (this.announcementBar) {
      this.headerContent.classList.add("announcement")
      this.headerLogo.classList.add("announcement")
    } else {
      this.headerContent.classList.remove("announcement")
      this.headerLogo.classList.remove("announcement")
    }

    ScrollTrigger.create({
      trigger: firstSection,
      start: "top top",
      end: "+=100%",
      scrub: true,
      onUpdate: self => {
        const progress = self.progress
        gsap.set(this.logo, {
          scale: window.innerWidth > 750 ? 1 - 0.855 * progress : 1 - 0.655 * progress,
          ease: "none",
        })

        if (this.announcementBar) {
          gsap.set(this.headerContent, {
            paddingTop: window.innerWidth < 750 ? 4.2 + "rem" : 7.2 - 3 * progress + "rem",
            ease: "none",
          })

          gsap.set(this.headerLogo, {
            top: window.innerWidth < 750 ? 0 : 3 - 3 * progress + "rem",
            ease: "none",
          })

          gsap.set(this.announcementBar, {
            y: -40 * progress,
            ease: "none",
          })
        }
      },
    })

    this.mobileLinks = qsa(".mobile-link", this.el)
  }

  updateBg(el, color) {
    const attr = color.charAt(0).toUpperCase() + color.slice(1)
    this.el.classList.forEach(className => {
      if (className.startsWith("is")) {
        this.el.classList.remove(className)
      }
    })
    this.el.classList.add(`is${attr}`)
  }

  tick({ scroll }) {
    this.current = scroll.current

    this.data.forEach(obj => {
      if (this.current >= obj.bounds.top - 40 && this.current <= obj.bounds.bottom + 40) {
        const color = obj.color
        this.updateBg(obj.el, color)
      }
    })
  }

  on() {
    gsap.set(this.logo, {
      scale: 1,
    })

    this.desktopLinks.forEach(link => {
      const currentPath = window.location.pathname.replace(/\/$/, "") // remove trailing slash
      const linkPath = link.getAttribute("href").replace(/\/$/, "") // get href directly

      // If the menu link is "/collections/all", highlight it for any page under "/collections"
      if (linkPath === "/collections/all" && currentPath.startsWith("/collections")) {
        link.classList.add("active")

        // Else do exact match
      } else if (currentPath === linkPath) {
        link.classList.add("active")
      }
    })

    this.mobileIcon.addEventListener("click", this.toggleMenu)
  }

  off() {
    this.desktopLinks.forEach(link => {
      link.classList.remove("active")
    })

    if (this.isActive) {
      this.toggleMenu()
    }

    this.mobileIcon.removeEventListener("click", this.toggleMenu)
  }

  getOffsetTop(el) {
    let y = 0
    while (el) {
      y += el.offsetTop
      el = el.offsetParent
    }
    return y
  }

  resize() {
    if (window.innerWidth < 750) {
      // toggle mobile
    } else {
      // close menu if it was open
      if (this.isActive) this.toggleMenu()
    }

    const scroll = this.current

    this.data = []

    this.bgs.forEach(bg => {
      const rect = bounds(bg)
      const color = bg.getAttribute("data-bg")

      rect.top = rect.top + scroll
      rect.bottom = rect.bottom + scroll + rect.height

      const obj = {
        el: bg,
        bounds: rect,
        color: color,
      }
      this.data.push(obj)
    })
  }

  toggleMenu = () => {
    this.isActive = !this.isActive

    this.el.classList.toggle("main-header_mobile_active")

    this.miniCart.classList.toggle("mini-cart-trigger_menuActive")
    this.mobileIcon.classList.toggle("mobile-icon_active")
    this.mobileMenu.classList.toggle("mobile-menu_active")
    this.logo.classList.toggle("logo_menuActive")

    if (this.isActive) {
      gsap.to(this.mobileMenu, {
        autoAlpha: 1,
      })
      gsap.from(this.mobileLinks, {
        y: "100%",
        stagger: 0.07,
        duration: 1.2,
      })
    } else {
      gsap.to(this.mobileMenu, {
        autoAlpha: 0,
      })
    }
  }
}
